import { Helmet } from 'react-helmet-async';

const UseHomeHelmet = () => (
  <Helmet key={'Trang chủ' || 'Thành Đồng Group'}>
    <title>Trang chủ | Thành Đồng Group</title>
    <meta
      name="description"
      content="Công ty TNHH XD TMDV Thành Đồng chuyên cung cấp dịch vụ vệ sinh công nghiệp, chống thấm, giúp việc nhà tại Cần Thơ."
    />
    <meta
      name="keywords"
      content="vệ sinh cần thơ, chống thấm cần thơ, giúp việc nhà, thành đồng"
    />
    <meta name="author" content="Thành Đồng Group" />
    <meta name="robots" content="index, follow" />

    <meta property="og:type" content="website" />
    <meta property="og:locale" content="vi_VN" />
    <meta property="og:title" content="Trang chủ | Thành Đồng Group" />
    <meta
      property="og:description"
      content="Chuyên cung cấp dịch vụ vệ sinh và chống thấm uy tín tại Cần Thơ. Thành Đồng là đơn vị hàng đầu trong ngành."
    />
    <meta property="og:url" content="https://thanhdong.katec.vn/" />
    <meta property="og:image" content="https://thanhdong.katec.vn/images/logo_thanh_dong.png" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Thành Đồng Group" />
    <meta
      name="twitter:description"
      content="Dịch vụ vệ sinh, giúp việc, chống thấm tại Cần Thơ."
    />
    <meta name="twitter:image" content="https://thanhdong.katec.vn/images/logo_thanh_dong.png" />

    <link rel="canonical" href="https://thanhdong.katec.vn/" />
  </Helmet>
);

export default UseHomeHelmet;
